import t from './POTemplate.type';
import * as purchaseOrderTemplateService from '../../../../services/Purchase-Order-template.service';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';

export const fetchTableData = (params, isAppend = false) => {
  return async (dispatch) => {
    try {
      const res = await purchaseOrderTemplateService.fetchPurchaseOrderRatioPackNames(params);
      if (res?.code === 200) {
        await dispatch({
          type: isAppend ? t.APPEND_PO_TEMPLATES : t.FETCH_PO_TEMPLATES,
          payload: res.data,
          pagination: res.pagination, // Include pagination metadata
        });
        return res;
      }
      const errorMsg = res?.data?.errMsg || res?.message || 'Failed to fetch PO templates';
      toasterMsg(errorMsg, 'danger');
      return { code: res?.code || 500, data: [], error: errorMsg };
    } catch (err) {
      console.error('Error in fetchTableData:', err);
      const errorMessage = err?.response?.data?.errMsg || err?.message || 'Network error occurred';
      toasterMsg(errorMessage, 'danger');
      return { code: 500, data: [], error: errorMessage };
    }
  };
};

export const fetchPurchaseOrderTemplateList = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await purchaseOrderTemplateService.fetchPurchaseOrderTemplateList(params);
      if (res?.code === 200) {
        await dispatch({
          type: t.FETCH_PO_TEMPLATE_LIST,
          payload: res.data,
        });
        return res;
      }
      const errorMsg = res?.data?.errMsg || res?.message || 'Failed to fetch PO template list';
      toasterMsg(errorMsg, 'danger');
      return { code: res?.code || 500, data: [], error: errorMsg };
    } catch (err) {
      console.error('Error in fetchPurchaseOrderTemplateList:', err);
      const errorMessage = err?.response?.data?.errMsg || err?.message || 'Network error occurred';
      toasterMsg(errorMessage, 'danger');
      return { code: 500, data: [], error: errorMessage };
    }
  };
};

export const fetchOldPoTemplateLibraries = (params, isAppend = false) => {
  return async (dispatch) => {
    try {
      const res = await purchaseOrderTemplateService.fetchOldPurchaseOrderTemplateLibraries(params);
      if (res?.code === 200) {
        await dispatch({
          type: isAppend ? t.APPEND_OLD_PO_TEMPLATES : t.FETCHING_OLD_PO_TEMPLATES,
          payload: res.data,
          pagination: res.pagination, // Include pagination metadata
        });
        return res;
      }
      // Handle non-200 responses
      const errorMsg = res?.data?.errMsg || res?.message || 'Failed to fetch old PO templates';
      toasterMsg(errorMsg, 'danger');
      return { code: res?.code || 500, data: [], error: errorMsg };
    } catch (err) {
      console.error('Error in fetchOldPoTemplateLibraries:', err);
      const errorMessage = err?.response?.data?.errMsg || err?.message || 'Network error occurred';
      toasterMsg(errorMessage, 'danger');
      return { code: 500, data: [], error: errorMessage };
    }
  };
};

export const resetOldPoTemplateLibraries = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.RESET_OLD_PO_TEMPLATES,
    });
  } catch (err) {
    console.error('Error in resetOldPoTemplateLibraries:', err);
  }
};

export const resetAllTemplates = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.RESET_ALL_TEMPLATES,
    });
  } catch (err) {
    console.error('Error in resetAllTemplates:', err);
  }
};

export const addPOTemplate = (template, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderTemplateService.addPurchaseOrderTemplate(template);
    if (res?.code === 200) {
      const message = transactionMsg(`PO_TEMPLATE.${res.message}`);
      toasterMsg(message, 'success');
    } else {
      const errorMsg = res?.data?.errMsg || res?.message || 'Failed to add purchase order template';
      const message = errorMsg.includes('PURCHASE_ORDER_TEMPLATE') ? transactionMsg(`PO_TEMPLATE.${errorMsg}`) : errorMsg;
      toasterMsg(message, 'danger');
    }
    return res;
  } catch (err) {
    const errorMessage = err?.response?.data?.errMsg || err?.message || 'Network error occurred';
    toasterMsg(errorMessage, 'danger');
  }
};

/**
 * Action to update an existing Purchase Order Template
 * @param {Object} template - Template data to update
 * @param {Function} transactionMsg - i18n/notification function
 */
export const updatePOTemplate = (template, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderTemplateService.updatePurchaseOrderTemplate(template);
    if (res?.code === 200) {
      const message = transactionMsg(`PO_TEMPLATE.${res.message}`);
      toasterMsg(message, 'success');
    } else {
      const errorMsg = res?.data?.errMsg || res?.message || 'Failed to update purchase order template';
      const message = errorMsg.includes('PURCHASE_ORDER_TEMPLATE') ? transactionMsg(`PO_TEMPLATE.${errorMsg}`) : errorMsg;
      toasterMsg(message, 'danger');
    }
    return res;
  } catch (err) {
    const errorMessage = err?.response?.data?.errMsg || err?.message || 'Network error occurred';
    toasterMsg(errorMessage, 'danger');
  }
};

/**
 * Action to delete one or more Purchase Order Templates by IDs
 * @param {string[]|string} ids - Array of template IDs or single ID
 * @param {Function} transactionMsg
 */
export const deletePOTemplate = (ids, transactionMsg) => async (dispatch) => {
  try {
    const templateIds = Array.isArray(ids) ? ids : [ids];

    const res = await purchaseOrderTemplateService.deletePurchaseOrderTemplate({ templateIds });
    if (res?.code === 200) {
      await dispatch({
        type: t.DELETE_PO_TEMPLATE,
        payload: templateIds,
      });

      let successMessage;
      if (templateIds.length === 1) {
        successMessage = res?.message || 'PURCHASE_ORDER.BACKEND_SERVER.SHARED.LIBRARY_SERVICE.PO_TEMPLATE_DELETED_SUCCESSFULY';
      } else {
        successMessage = res?.message || 'PURCHASE_ORDER.BACKEND_SERVER.SHARED.LIBRARY_SERVICE.PO_TEMPLATES_DELETED_SUCCESSFULY';
      }
      const message = successMessage.includes('BACKEND_SERVER') ? transactionMsg(successMessage) : transactionMsg(`PURCHASE_ORDER.${successMessage}`);
      toasterMsg(message, 'success');
    } else {
      const errorMessage = res?.data?.errMsg || res?.errMsg || res?.message || 'DELETE_FAILED';
      const message =
        errorMessage.includes('BACKEND_SERVER') || errorMessage.includes('PURCHASE_ORDER')
          ? transactionMsg(errorMessage)
          : transactionMsg(`PURCHASE_ORDER.BACKEND_SERVER.SHARED.LIBRARY_SERVICE.${errorMessage}`);
      toasterMsg(message, 'danger');
    }
    return res;
  } catch (err) {
    console.error('Error in deletePOTemplate:', err);
    const errorMessage = err?.response?.data?.errMsg || err?.response?.data?.message || err?.message || 'Network error occurred while deleting templates';
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

/**
 * Action to delete one or more Old Purchase Order Templates by IDs
 * @param {string[]|string} ids - Array of template IDs or single ID
 * @param {Function} transactionMsg
 */
export const deleteOldPOTemplate = (ids, transactionMsg) => async (dispatch) => {
  try {
    const templateIds = Array.isArray(ids) ? ids : [ids];

    const res = await purchaseOrderTemplateService.deleteOldPurchaseOrderTemplate({ templateIds });

    if (res?.code === 200) {
      await dispatch({
        type: t.DELETE_OLD_PO_TEMPLATE,
        payload: templateIds,
      });

      let successMessage;
      if (templateIds.length === 1) {
        successMessage = res?.message || 'PURCHASE_ORDER.BACKEND_SERVER.SHARED.LIBRARY_SERVICE.PO_TEMPLATE_DELETED_SUCCESSFULY';
      } else {
        successMessage = res?.message || 'PURCHASE_ORDER.BACKEND_SERVER.SHARED.LIBRARY_SERVICE.PO_TEMPLATES_DELETED_SUCCESSFULY';
      }

      const message = successMessage.includes('BACKEND_SERVER') ? transactionMsg(successMessage) : transactionMsg(`PURCHASE_ORDER.${successMessage}`);
      toasterMsg(message, 'success');
    } else {
      const errorMessage = res?.data?.errMsg || res?.errMsg || res?.message || 'DELETE_FAILED';
      const message =
        errorMessage.includes('BACKEND_SERVER') || errorMessage.includes('PURCHASE_ORDER')
          ? transactionMsg(errorMessage)
          : transactionMsg(`PURCHASE_ORDER.BACKEND_SERVER.SHARED.LIBRARY_SERVICE.${errorMessage}`);
      toasterMsg(message, 'danger');
    }
    return res;
  } catch (err) {
    console.error('Error in deleteOldPOTemplate:', err);
    const errorMessage = err?.response?.data?.errMsg || err?.response?.data?.message || err?.message || 'Network error occurred while deleting templates';
    toasterMsg(errorMessage, 'danger');
    return { code: 500, error: errorMessage };
  }
};

/**
 * Action to update isActive for one or more Purchase Order Templates
 * @param {string[]|string} ids - Array of template IDs or single ID
 * @param {boolean} isActive - Desired isActive state
 * @param {Function} transactionMsg
 */
export const updatePOTemplateActive = (id, isActive, transactionMsg) => {
  return async (dispatch) => {
    try {
      const res = await purchaseOrderTemplateService.updatePurchaseOrderTemplateActive({ templateId: id, isActive });
      if (res?.code === 200) {
        await dispatch({
          type: t.UPDATE_PO_TEMPLATE_ACTIVE,
          payload: { id, isActive },
        });
        const message = transactionMsg(`PO_TEMPLATE.${res?.message}`);
        toasterMsg(message, 'success');
      } else {
        toasterMsg(transactionMsg(`PO_TEMPLATE.${res?.data?.errMsg}`), 'danger');
      }
      return res;
    } catch (err) {
      toasterMsg(err?.toString(), 'danger');
    }
  };
};

/**
 * Action to duplicate a Purchase Order Template by ID
 * @param {string} templateId - The ID of the template to duplicate
 * @param {string} newName - The name for the duplicated template
 * @param {Function} transactionMsg - i18n/notification function
 */
export const duplicatePOTemplate = (templateId, newName, transactionMsg) => async () => {
  try {
    const payload = { templateId, newName };
    const res = await purchaseOrderTemplateService.duplicatePurchaseOrderTemplate(payload);
    if (res?.code === 200) {
      toasterMsg(transactionMsg(`PO_TEMPLATE.${res.message}`), 'success');
    } else {
      toasterMsg(transactionMsg(`PO_TEMPLATE.${res.data?.errMsg}`), 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    return null;
  }
};

export const getPurchaseOrderTemplateDetails =
  (id, isNewPreview = false) =>
  async (dispatch) => {
    try {
      const res = await purchaseOrderTemplateService.getPurchaseOrderTemplateDetails(id);
      if (res?.code === 200) {
        if (isNewPreview) {
          dispatch({
            type: t.GET_NEW_PREVIEW_DATA,
            payload: res.data,
          });
        } else {
          dispatch({
            type: t.GET_POTEMPLATE_DETAILS,
            payload: res.data,
          });
        }
      }
      return res;
    } catch (err) {
      toasterMsg(err.toString(), 'danger');
    }
  };

export const clearPurchaseOrderTemplateDetails = () => async (dispatch) => {
  dispatch({ type: t.RESET_POTEMPLATE_DETAILS });
};

/**
 * Action to rearrange sections in a Purchase Order Template
 * @param {string} templateId - The ID of the template
 * @param {Array} sections - Array of sections with updated sequences
 * @param {Function} transactionMsg - i18n/notification function
 */
export const rearrangePOTemplateSections = (templateId, sections, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderTemplateService.rearrangePurchaseOrderTemplateSections(templateId, sections);
    if (res?.code === 200) {
      const message = transactionMsg(`PO_TEMPLATE.${res.message}`);
      toasterMsg(message, 'success');
    } else {
      toasterMsg(res?.data?.errMsg?.includes('PURCHASE_ORDER_TEMPLATE') ? transactionMsg(`PO_TEMPLATE.${res.data.errMsg}`) : res.data.errMsg, 'danger');
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPreviewData = (id) => {
  return async (dispatch) => {
    try {
      const res = await purchaseOrderTemplateService.fetchPreviewData(id);
      if (res?.code === 200) {
        await dispatch({
          type: t.GET_PREVIEW_DATA,
          payload: res.data,
        });
        await dispatch({
          type: 'GET_PREVIEW_DATA', // P.O.Template action type
          payload: res.data,
        });
        return true;
      }
      const errorMsg = res?.data?.errMsg || res?.message || 'Failed to fetch preview data';
      toasterMsg(errorMsg, 'danger');
      return false;
    } catch (err) {
      console.error('Error in fetchPreviewData:', err);
      const errorMessage = err?.response?.data?.errMsg || err?.message || 'Network error occurred';
      toasterMsg(errorMessage, 'danger');
      return false;
    }
  };
};

export const clearPreviewData = () => {
  return async (dispatch) => {
    try {
      await dispatch({
        type: t.CLEAR_PREVIEW_DATA,
      });
      // Also clear P.O.Template reducer preview data
      await dispatch({
        type: 'CLEAR_DATA', // P.O.Template action type
      });
      return true;
    } catch (err) {
      console.error('Error in clearPreviewData:', err);
      return false;
    }
  };
};
